import { render, staticRenderFns } from "./Addresses.vue?vue&type=template&id=350703f9&scoped=true&"
import script from "./Addresses.vue?vue&type=script&lang=js&"
export * from "./Addresses.vue?vue&type=script&lang=js&"
import style0 from "./Addresses.vue?vue&type=style&index=0&id=350703f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350703f9",
  null
  
)

export default component.exports